import { render } from "./AppLoader.vue?vue&type=template&id=2ac88723"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=2ac88723&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__